const PassengerType={
    All:0,
    Zaer:1,
    NoZaer:2
}
const AppId={
    UserManagment:"1",
    Plan:"2",
    Transport:"3",
    Assignment:"4",
    Dashboard:"5",
    Survey:"8"
  }
  const FlightType={
    Departure:0,
    Return:1
  }
  const PackageDetailsEventType=
{
  //رسیدن
    Arrive:0,
   //سفر بین شهری
    InterCity:1,
   //سفر درون شهری
    InnerCity:2,
   //حمل بار
    Cargo:3,
   //خروج
    Exit:4,
   //در اختیار کاروان
    AtTheDisposalOfTheGroup:5,
    //در اختیار خود
    AtYourDisposal:6,
    //درخواست رزرو پلان
    ReservePlanRequest:7
}
const FlightTimeMode={
  Ontime:"1",
  WithDelay:"2",
  WithRush:"3"
}
const AddEditMode={
  Add:1,
  Edit:2
}

const EnumMapper={PassengerType, AppId,FlightType, PackageDetailsEventType,FlightTimeMode,AddEditMode}
export default EnumMapper